import {BaseModel} from "../../../../../infrastructure/models/base-model";
import {computed} from "mobx";

export class SideBarEntityScoresTabModel extends BaseModel {
  constructor(model, terms) {
    super();

    this.index = model.index;
    this.filterName = model.filterName;
    this.aliasName = model.aliasName;
    this.terms = terms;
  }

  @computed get name() {
    return this.terms[`${this.aliasName}`];
  }
}
